import React from 'react'

import { NumberInputProps } from './NumberInput.types'

import { ArrowClockwise, Hash } from 'react-bootstrap-icons'

import './NumberInput.scss'

export const NumberInput: React.FC<NumberInputProps> = ({
  inputProps = { defaultValue: 0 },
  icon = <Hash />,
  hidden,
  style,
  reset,
}) => {
  // console.log(inputProps)
  // console.log(hidden)
  return (
    <div 
      className={hidden ? undefined : `${inputProps.disabled && 'number-input-disabled'} number-input`}  
      style={{ 
        width: '100%', 
        ...style, 
        position: 'relative'
      }}
    >
      {icon && !hidden && (
        <i style={{
          position: 'absolute',
          height: '100%',
          width: 34,
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          color: 'white',
          // zIndex: 20,
          fill: inputProps.disabled ? 'var(--slate11)' : 'var(--primary)' 
        }}
        >
          {icon}
        </i>
      )}
      <input
        style={{
          paddingLeft: 35,
          borderRadius: 4,
          flex: 12,
          width: '100%',
          fontSize: '0.9rem'
        }}
        {...inputProps}
        type={hidden ? 'hidden' : 'number'}
      />
      { !hidden && typeof inputProps.defaultValue !== 'undefined' && !inputProps.disabled &&
      <button
        type='button'
        onClick={reset}
        style={{
          background: 'white'
        }}
      >
        <ArrowClockwise style={{ fill: 'var(--primary)' }}/>
      </button>
      }
    </div>
  )}

export default NumberInput